module.exports = __webpack_public_path__ + "static/media/dropdown.a75d7fe5.svg";